export default {
  title: 'Weet u het zeker?',
  description: 'De volgende optiegroepen (inclusief hun opties) worden verwijderd:',
  buttons: {
    yes: 'Ja',
    no: 'Nee',
  },
  toasts: {
    modifier_group_got_deleted: 'Optiegroepen zijn verwijderd',
    failed_to_delete_modifier_group: 'Verwijderen van de optiegroep mislukt',
  },
};
